module.exports = __webpack_public_path__ + "img/circle.d8819f7b.png";